<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox" v-loading="loading">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>工单信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">工单信息</span>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div>
              <div class="title">投诉原因</div>
              <div>{{ detail.complainTypeName }}</div>
            </div>
            <div>
              <div class="title">投诉人</div>
              <div>{{ detail.complainantName }}</div>
            </div>
            <div>
              <div class="title">投诉人联系方式</div>
              <div>{{ detail.complainantPhone }}</div>
            </div>
            <div>
              <div class="title">被投诉人</div>
              <div>{{ detail.respondentName }}</div>
            </div>
            <div>
              <div class="title">被投诉人联系方式</div>
              <div>{{ detail.respondentPhone }}</div>
            </div>
          </div>
        </el-card>
      </div>
      <div style="margin-top: 20px">
        <el-card class="box-card" shadow="never">
          <div style="display: flex; justify-content: space-between">
            <div style="width: 50%">
              <div class="dis">
                <div class="title" style="margin-bottom: 0">关联订单</div>
                <div
                  style="
                    color: blue;
                    cursor: pointer;
                    font-size: 16px;
                    margin-left: 20px;
                  "
                  @click="goDetail1({ id: detail.jobId })"
                >
                  查看订单详情
                </div>
              </div>
              <div class="dis">
                <div class="title" style="margin-bottom: 0">投诉时间</div>
                <div style="margin-left: 20px">{{ detail.submitAt }}</div>
              </div>
              <div class="dis">
                <div class="title" style="margin-bottom: 0; flex: none">
                  附件证据
                </div>
                <div
                  style="margin-left: 20px; display: flex; flex-wrap: wrap"
                  v-if="
                    detail.complainantAttachmentList &&
                    detail.complainantAttachmentList.length
                  "
                >
                  <el-image
                    v-for="(item, index) in detail.complainantAttachmentList"
                    :key="index"
                    :src="item"
                    alt=""
                    style="
                      width: 150px;
                      height: 50px;
                      margin-right: 10px;
                      margin-bottom: 10px;
                    "
                    :preview-src-list="[item]"
                  />
                </div>
              </div>
            </div>
            <div style="width: 50%">
              <div class="dis">
                <div class="title">工单状态</div>
                <div>
                  <el-select
                    :disabled="detail.status == 2 ? true : false"
                    v-model="status1"
                    placeholder="请选择状态"
                    style="margin-left: 20px"
                  >
                    <el-option label="待处理" value="0"></el-option>
                    <el-option label="处理中" value="1"></el-option>
                    <el-option label="已处理" value="2"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="dis">
                <div class="title" style="flex: none">上传附件</div>
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    style="
                      width: 100px;
                      height: 100px;
                      position: relative;
                      margin-right: 10px;
                      margin-bottom: 10px;
                    "
                    v-if="imgList.length"
                    v-for="(value, index) in imgList"
                    :key="index"
                  >
                    <i
                      v-if="detail.status != 2"
                      class="el-icon-circle-close"
                      style="
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        cursor: pointer;
                        font-size: 20px;
                        z-index: 2;
                      "
                      @click="handleRemove(index)"
                    ></i>
                    <el-image
                      :src="value"
                      class="avatar"
                      style="width: 100%; height: 100%"
                      :preview-src-list="[value]"
                    />
                  </div>
                  <el-upload
                    class="avatar-uploader"
                    accept="image/*"
                    :action="uploadUrl"
                    :headers="deader"
                    :multiple="true"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    :disabled="detail.status == 2 ? true : false"
                  >
                    <i
                      v-if="detail.status != 2"
                      class="el-icon-plus avatar-uploader-icon"
                      style="margin-top: 50px"
                    ></i>
                  </el-upload>
                </div>
              </div>
              <div style="margin-top: 20px" class="dis">
                <div class="title" style="margin-left: 30px">备注</div>
                <div style="margin-left: 20px">
                  <el-input
                    :disabled="detail.status == 2 ? true : false"
                    type="textarea"
                    v-model="remark"
                    style="min-width: 400px"
                    :rows="4"
                    maxlength="500"
                    placeholder="请输入备注信息字数500字之内"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <div style="margin-top: 20px">
        <el-card class="box-card" shadow="never">
          <div style="display: flex; justify-content: space-between">
            <div style="width: 50%">
              <div class="dis">
                <div class="title" style="margin-bottom: 0">保安待结算金额</div>
                <div style="margin-left: 20px">
                  ￥{{ detail.securityPendingAmount }}
                </div>
              </div>
              <div class="dis">
                <div class="title" style="margin-bottom: 0">确认结算金额</div>
                <div style="margin-left: 20px">
                  <el-input
                    :disabled="detail.status == 2 ? true : false"
                    v-model="money"
                    type="number"
                    maxlength="7"
                    placeholder="请输入结算金额"
                  ></el-input>
                </div>
              </div>
            </div>
            <div style="width: 50%">
              <div class="dis">
                <div class="title">异常记录</div>
                <div
                  style="margin-left: 20px"
                  v-if="detail.abnormalRecords != ''"
                >
                  <div
                    v-for="(item, index) in detail.abnormalRecords"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style="width: 100%; text-align: center"
            v-if="detail.status != 2"
          >
            <el-button type="primary" style="margin-top: 20px" @click="confrim"
              >提交工单</el-button
            >
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.customerData(),
      status1: "",
      remark: "",
      money: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      uploadUrl: "",
      imgList: [],
      edit: "",
      detail: "",
      loading: false,
    };
  },
  mounted() {
    this.edit = this.$route.query.id;
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
    this.getDetail();
  },
  methods: {
    confrim() {
      if (
        this.money != "" &&
        Number(this.money) > this.detail.securityPendingAmount
      ) {
        this.$message.error("确认结算金额不能大于待结算金额");
        return;
      }
      if (this.money != "" && Number(this.money) < 0) {
        this.$message.error("确认结算金额不能小于0");
        return;
      }
      const param = {
        id: this.edit,
        status: this.status1,
        remark: this.remark,
        confirmedSettlementAmount: this.money,
        attachments: this.imgList,
      };
      this.$axios
        .post(`/admapi/job/litigationOrder/submit`, param)
        .then(({ data }) => {
          this.$message.success("工单处理成功");
          this.$router.push({ path: "/workOrder" });
        })
        .catch()
        .finally();
    },
    beforeAvatarUpload(res) {
      this.loading = true;
    },
    handleAvatarSuccess(res) {
      this.imgList = this.imgList.concat(res.data);
      this.loading = false;
    },
    handleRemove(index) {
      console.log(index);
      let arr = this.imgList;
      arr.splice(index, 1);
      this.imgList = arr;
    },
    getDetail() {
      this.$axios
        .get(`/admapi/job/litigationOrder/detail/${this.edit}`)
        .then(({ data }) => {
          let obj = data;
          obj.abnormalRecords = JSON.parse(data.abnormalRecords || "[]");
          this.detail = obj;
          this.status1 = JSON.stringify(data.status);
          this.remark = data.remark;
          this.money = data.confirmedSettlementAmount;
          this.imgList = data.operatorsAttachmentList || [];
        })
        .catch()
        .finally();
    },
    goDetail1(row) {
      window.open(
        this.$router.resolve({
          path: "/taskDetail",
          query: { id: row.id },
        }).href,
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.dis {
  display: flex;
  /* align-items: center; */
  font-size: 16px;
  margin-bottom: 20px;
}
</style>
